import { nxConfig } from '@nv/utils'
import axios from 'axios'

const VoterRegistrationService = {
  searchAddress: async (search) => {
    try {
      const limit = 20
      const resp = await axios.get(`${nxConfig.PUBLIC_URL}/addresses?search=${search}&limit=${limit}`)
      return { success: true, data: resp.data }
    } catch (error) {
      return { error: error.response?.data?.error }
    }
  },
  voterLookup: async (data) => {
    try {
      const response = await axios.post(`${nxConfig.PUBLIC_URL}/registration/lookup`, data)
      return { onElectorsList: response.data.electorOnList }
    } catch (error) {
      return { error: error.response?.data?.error }
    }
  },
  checkEligible: async (data) => {
    try {
      await axios.post(`${nxConfig.PUBLIC_URL}/registration/checkeligible`, data)
      return { success: true }
    } catch (error) {
      return { error: error.response?.data?.error }
    }
  },
  sendSMSCode: async (phone, recaptchaToken) => {
    try {
      await axios.post(`${nxConfig.PUBLIC_URL}/registration/mfa/initiate/sms`, {
        phone,
        recaptchaToken,
      })
      return { success: true }
    } catch (error) {
      //console.log(error)
      return { error: error.response?.data?.error }
    }
  },
  sendEmailCode: async (email, recaptchaToken) => {
    try {
      await axios.post(`${nxConfig.PUBLIC_URL}/registration/mfa/initiate/email`, { email, recaptchaToken })
      return { success: true }
    } catch (error) {
      //console.log(error)
      return { error: error.response?.data?.error }
    }
  },
  // full registration call
  verifySMSCode: async (input) => {
    try {
      const result = await axios.post(`${nxConfig.PUBLIC_URL}/registration/mfa/verify/sms`, input)
      const data = result.data?.data
      return {
        success: true,
        data,
        userData: data,
        applicationCode: data?.applicationCode,
        status: data?.status,
      }
    } catch (error) {
      //console.log(error)
      return { error: error.response?.data?.error }
    }
  },
  verifyEmailCode: async (input) => {
    try {
      const result = await axios.post(`${nxConfig.PUBLIC_URL}/registration/mfa/verify/email`, input)
      const data = result.data?.data
      return {
        success: true,
        data,
        userData: data,
        applicationCode: data?.applicationCode,
        status: data?.status,
      }
    } catch (error) {
      //console.log(error)
      return { error: error.response?.data?.error }
    }
  },
  registerRecaptchaVerification: async (input) => {
    try {
      const result = await axios.post(`${nxConfig.PUBLIC_URL}/registration/recaptcha/verify`, input)
      const data = result.data?.data
      return {
        success: true,
        data,
        userData: data,
        applicationCode: data?.applicationCode,
        status: data?.status,
      }
    } catch (error) {
      //console.log(error)
      return { error: error.response?.data?.error }
    }
  },
  answerSurvey: async (payload) => {
    try {
      await axios.put(`${nxConfig.PUBLIC_URL}/registration/${payload.id}`, payload)
      return { success: true }
    } catch (error) {
      //console.log(error)
      return { error: error.response?.data?.error }
    }
  },
  verifyStatus: async ({ confirmCode }) => {
    try {
      const result = await axios.get(`${nxConfig.PUBLIC_URL}/application-status/${confirmCode}`)

      return result
    } catch (error) {
      //console.log(error)
    }
  },
}

export default VoterRegistrationService
